var map = {
	"./OpenSans-Bold.ttf": 568,
	"./OpenSans-BoldItalic.ttf": 569,
	"./OpenSans-Italic.ttf": 570,
	"./OpenSans-LightItalic.ttf": 571,
	"./OpenSans-Regular.ttf": 572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;